var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terminology-component-container"},[_c('div',{staticClass:"term",domProps:{"innerHTML":_vm._s(_vm.flashcard.question)}}),_vm._v(" "),_c('div',{staticClass:"answer",class:{ show: _vm.answered }},[(_vm.answered)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.definition)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }